import $ from 'jquery'
import lottie from 'lottie-web'

// The JSON is served from the asset CDN, another origin that rejects CORS preflights. A bare
// XHR with no custom headers stays a "simple" request; $.ajax would pick up the app-wide
// X-CSRF-Token header (application/application.js) and force a preflight. XHR rather than
// fetch: .browserslistrc still targets IE 11 and nothing polyfills fetch.
function requestJSON(url) {
  return new Promise((resolve, reject) => {
    const xhr = new XMLHttpRequest()
    const failed = () => reject(new Error(`Animation request failed with status ${xhr.status}: ${url}`))

    xhr.open('GET', url)
    xhr.onerror = failed
    xhr.onload = () => {
      if (xhr.status < 200 || xhr.status >= 300) return failed()

      try {
        resolve(JSON.parse(xhr.responseText))
      } catch {
        reject(new Error(`Animation response is not valid JSON: ${url}`))
      }
    }
    xhr.send()
  })
}

export async function loadAnimation(element) {
  const animationData = await requestJSON(element.dataset.src)

  lottie.loadAnimation({
    animationData,
    container: element,
    renderer: 'svg',
    loop: true,
    autoplay: true,
    rendererSettings: {
      className: 'svg-homepage-wrapper'
    }
  })
}

$('.animation-shortcode').each((_index, element) => {
  // Decorative: on failure the container stays empty; log instead of an unhandled rejection.
  loadAnimation(element).catch(error => console.error(error))
})
